module.exports = __webpack_public_path__ + "img/imagen-tarjeta-arenas.7ab164a0.png";